import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { PosService } from 'src/app/services/pos/pos.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
declare var $: any;

@Component({
  selector: 'app-order-actions',
  templateUrl: './order-actions.component.html',
  styleUrls: ['./order-actions.component.scss'],
})
export class OrderActionsComponent implements OnInit {
  fromadd: boolean = true;

  loggedUserRole: any;

  oderActionDetails = [];
  isOderActionTab = false;
  orderActionLoader = false;
  orderActionFilterSelected = false;
  selectedFilterFranchise: any = null;
  selectedFilterShop: any = null;
  isFilterClicked = false;
  selectedShop: any;
  selectedShopName: any;
  isActionClick: boolean;
  lastSyncedDate: any;
  syncMessage = '';
  isSyncSuccess = false;
  testOrderMessage = '';
  isTestSuccess = false;
  available_time: any;
  acceptingOrderDetails: any = {};
  acceptingOrderValue: any;
  acceptMessage = '';
  prepTimeUpdateMsg = '';
  prepTimeUpdateSuccess: boolean = false;
  acceptSuccess: boolean = false;
  acceptSubmit: boolean = false;
  isAcceptLoading: boolean = false;
  onChangeAutoAcceptingValue: any;
  acceptEvent: any = '';

  franchises: any;
  shops: any = [];
  toggleAccess = false;
  isUpdateModifierSelected: boolean = false;

  filterAvailability: boolean = false;
  filterSearchAvailability: boolean = false;
  filterClickHeight: number = 20;
  filterNotClickHeight: number = 25;
  platformId: any;
  submitted: boolean = false;
  tableConfig: Array<object> = [
    { id: 1, header: 'Integration ID' },
    {
      id: 2,
      header: 'Integration Name',
      sort: false,
      classType: 'tableHeader',
    },
    { id: 3, header: 'Accepting Orders', classType: 'tableHeader' },
    { id: 4, header: 'Own Driver', classType: 'tableHeader' },
    { id: 5, header: 'Auto Accepting', classType: 'tableHeader' },
    { id: 6, header: 'Prep Time', classType: 'tableHeader' },
    { id: 7, header: 'Test Order', classType: 'tableHeader' },
  ];
  tableAction: Array<object> = [
    { id: 'edit', type: 'Edit', image: '../../../../../assets/icons/edit.png' },
    {
      id: 'edit',
      type: 'Delete',
      image: '../../../../../assets/icons/delete.png',
    },
  ];

  tableInfo: Array<object> = [
    { id: 1, header: 'id', type: 'Number', classType: 'tableDataFirstCol' },
    { id: 2, header: 'name', type: 'String', classType: 'tableData' },
    { id: 3, header: 'isAccepting', type: 'Switch', classType: 'tableData' },
    { id: 4, header: 'isOwnDriver', type: 'DriverSwitch', classType: 'tableData' },
    {
      id: 5,
      header: 'isAutoAccepting',
      type: 'Switch',
      classType: 'tableData',
    },
    {
      id: 6,
      header: 'prepTime',
      type: 'Dropdown',
      classType: 'tableData',
    },
    {
      id: 7,
      header: 'testOrderBtn',
      type: 'TestOrderButton',
      classType: 'tableData',
    },
  ];
  // oderActionsSelector: Boolean = true;

  deliveryOptions = [
    { id: 1, name: 'DELIVERY' },
    { id: 2, name: 'COLLECTION' },
  ];
  availableTimes = [
    { id: 0, timeZone: '1 Hour', day: 'today', value: '1_hour' },
    { id: 1, timeZone: '3 Hours', day: 'today', value: '3_hour' },
    { id: 2, timeZone: 'Next Day', day: 'other', value: 'next_day' },
    { id: 3, timeZone: '1 Week', day: 'other', value: '1_week' },
    { id: 4, timeZone: 'Forever', day: 'other', value: 'forever' },
  ];
  constructor(
    private authService: AuthenticationService,
    private deliveryService: DeliveryPlatformService,
    private spinner: NgxSpinnerService,
    private adminService: AdminService,
    private posService: PosService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.getCurrentUser();
    this.getAllFranchise();
    this.geOutlets();

    $('.selectpicker').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('refresh');
    $('#spicker_franchise1').selectpicker('val');
    $('#spicker_franchise_auto_aceept').selectpicker('refresh');
    $('#spicker_shop_auto_accept').selectpicker('refresh');
    $('#spicker_franchise_auto_aceept').selectpicker('val');

  }

  form: FormGroup = new FormGroup({
    first_name: new FormControl([]),
    last_name: new FormControl([]),
    email: new FormControl([]),
    password: new FormControl([])
  })

  get f() {
    return this.form.controls;
  }

  placeTestOrderForm: FormGroup = new FormGroup({
    platform_id: new FormControl('', [Validators.required]),
    delivery_type: new FormControl('', [Validators.required]),
  });

  get placeOrder() {
    return this.placeTestOrderForm.controls;
  }

  filterForm: FormGroup = new FormGroup({
    franchise: new FormControl(''),
    shop: new FormControl(''),
    franchise_pos: new FormControl(''),
    shop_pos: new FormControl(''),
    shop_auto_aceept: new FormControl(''),
    franchise_auto_aceept: new FormControl(''),
  });

  availableForm: FormGroup = new FormGroup({
    available_from: new FormControl('', [Validators.required]),
  });
  get sf() {
    return this.availableForm.controls;
  }

  getCurrentUser() {
    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole == 4) {
      this.selectedFilterFranchise =
        this.authService.getLoggedUser().shops[0].franchise_id;
      this.selectedFilterShop = this.authService.getLoggedUser().shops[0].id;
      this.getOrderActions();
    }
    let policies = this.authService.getLoggedUser().policies;

    policies.forEach((element) => {
      if (element.id == 14) {
        this.toggleAccess = true;
      }
    });
  }

  getAllFranchise() {
    this.adminService
      .getAllFranchises()
      .subscribe({
        next: (res) => {
          this.franchises = res.data;
          $('#spicker_franchise_int').selectpicker('refresh');
          $('#spicker_franchise_int').selectpicker('val');
          $('#spicker_franchise_pos').selectpicker('refresh');
          $('#spicker_franchise_pos').selectpicker('val');
          $('#spicker_franchise_auto_aceept').selectpicker('refresh');
          $('#spicker_franchise_auto_aceept').selectpicker('val');
        },
        error: (error) => {
          console.log(error + 'Error');
        }
      });
  }

  geOutlets() {
    this.adminService.getOutlets().subscribe((res) => {
      this.shops = res.data;
    });
  }

  refreshFilters() {
    if (!this.isFilterClicked) {
      this.isFilterClicked = true;
    } else {
      this.isFilterClicked = false;
    }

    $('#spicker_franchise_oa').selectpicker('refresh');
    $('#spicker_franchise_oa').selectpicker('val');

    this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;
    if (this.loggedUserRole > 2) {
      setTimeout(function () {
        $('#spicker_shop_oa').removeAttr('disabled');
        $('#spicker_shop_oa').selectpicker('refresh');
      }, 1);
    }
  }

  async selectFranchise(e) {

    this.orderActionLoader = true;
    if (this.fromadd) {
      if (e) {
        await this.adminService
          .getShopsRelatedFranchise(e)
          .subscribe({
            next: (res) => {

              this.shops = res.data;
              this.selectedFilterFranchise = e;
              this.selectedFilterShop = null;
              this.getOrderActions();
              setTimeout(function () {
                $('#spicker_shop_auto_accept').removeAttr('disabled');
                $('#spicker_shop_auto_accept').selectpicker('refresh');
                $('#spicker_shop_auto_accept').selectpicker('val', '');

                $('#spicker_shop_oa').removeAttr('disabled');
                $('#spicker_shop_oa').selectpicker('refresh');
                $('#spicker_shop_oa').selectpicker('val', '');
              }, 1);
              this.orderActionLoader = false;
            },
            error: (error) => this.orderActionLoader = false

          });
      }
    }
  }

  selectShop(e) {
    if (e) {
      this.selectedFilterShop = e.id;
      this.getOrderActions();
      this.orderActionLoader = false;
    }
    for (let int of this.oderActionDetails) {
      if (int.shopActions.length > 1) {
        this.filterClickHeight = 28;
        this.filterNotClickHeight = 30;
      }
    }
  }

  selectTimezone(values: any) {
    this.acceptMessage = '';
    this.available_time = values.value;
  }

  onChangeAutoAccepting(values) {
    this.onChangeAutoAcceptingValue = values;
    let int = values.int;
    let e = values.e;
    let data;
    if (e == 1) {
      data = {
        auto_accepting: 0,
        store_status: int.isAccepting,
      };
    } else {
      data = {
        auto_accepting: 1,
        store_status: int.isAccepting,
      };
    }
    this.deliveryService
      .updateAutoAcceptingAndAccepting(int.id, data)
      .subscribe({
        next: (res) => {
          this.getOrderActions();
        },
        error: (error) => {
          console.log(error + 'Error')
        }
      });
  }

  onChangeAccepting(values) {

    let int = values.int;
    this.acceptingOrderValue = int;
    let e = values.e;
    let data;
    if (e == 1) {
      $('#snoozeOrderModal').modal('show');
    } else {
      data = {
        auto_accepting: int.isAutoAccepting,
        store_status: 1,
      };
      this.deliveryService
        .updateAutoAcceptingAndAccepting(int.id, data)
        .subscribe({
          next: (res) => {
            this.getOrderActions();
          },
          error: (error) => {
            console.log(error + 'Error');
          }
        });
    }
  }

  onOwnDriverChange(values) {
    console.log(values, "onOwnDriverChange");

    let int = values.int;
    let e = values.e;

    let data;
    if (e == 1) {
      data = {
        own_driver: 0,
      };
    } else {
      data = {
        own_driver: 1,
      };
    }
    this.deliveryService
      .updateOwnDriverStatus(int.id, data)
      .subscribe({
        next: (res) => {
          this.getOrderActions();
        },
        error: (error) => {
          console.log(error + 'Error');
        }
      });

  }
  getOrderActions() {

    this.deliveryService
      .getOrderActions(this.selectedFilterFranchise, this.selectedFilterShop)
      .subscribe({
        next: (res) => {
          console.log(res.data, "getOrderActions");
          this.orderActionFilterSelected = true;
          this.orderActionLoader = true;
          this.oderActionDetails = res.data;
        },
        error: (error) => {
          console.log(error + 'Error');
        }
      });
  }

  closeModal() {
    this.isUpdateModifierSelected = false;
    this.syncMessage = '';
    $('#syncPosModal').modal('hide');
  }

  posActionosClick() {
    this.selectedShop = this.authService.getLoggedUser().shops[0];
    this.selectedShopName = this.selectedShop.name;
    this.lastSyncedDate = this.selectedShop.last_pos_synced;
    $('#syncPosModal').modal('show');
  }

  updateModifiers() {
    if (this.isUpdateModifierSelected) {
      this.isUpdateModifierSelected = false;
    } else {
      this.isUpdateModifierSelected = true;
    }
  }

  syncPOS() {
    this.isActionClick = true;
    this.posService
      .syncPOS(this.selectedShop.id, this.isUpdateModifierSelected)
      .subscribe({
        next: (res) => {
          this.getOrderActions();
          this.isActionClick = false;
          this.syncMessage = res.message;
          this.isSyncSuccess = true;
        },
        error: (error) => {
          console.log(error + 'Error');
          this.isActionClick = false;
          this.isSyncSuccess = false;
          this.syncMessage = error;
        }
      });
  }

  onCancel() {
    $('#placeOrderModal').modal('hide');
  }

  openPlaceTestOrder(item) {
    this.testOrderMessage = '';
    this.platformId = item.data;
    this.placeTestOrderForm.patchValue({
      platform_id: this.platformId,
      delivery_type: '',
    });
    $('#placeOrderModal').modal('show');
  }

  placeTestOrder() {
    this.testOrderMessage = '';
    this.submitted = true;
    this.isActionClick = true;

    if (this.placeTestOrderForm.invalid) {
      this.form.setErrors({
        invalidLogin: true,
      });
      this.isActionClick = false;
    } else {
      this.deliveryService
        .placeTestOrder(this.placeTestOrderForm.value)
        .subscribe({
          next: (res) => {
            this.getOrderActions();
            this.isActionClick = false;
            this.submitted = false;
            this.testOrderMessage = res.message;
            this.isTestSuccess = true;
            this.placeTestOrderForm.reset();
            $('#placeOrderModal').modal('hide');
          },
          error: (error) => {
            console.log(error + 'Error');
            this.isActionClick = false;
            this.isTestSuccess = false;
            this.submitted = false;
            this.testOrderMessage = error;
          }
        });
    }
  }

  snoozeOrder() {
    this.acceptSubmit = true;
    this.isAcceptLoading = true;
    this.acceptingOrderDetails = {
      auto_accepting: this.acceptingOrderValue.isAutoAccepting,
      store_status: 0,
      available_from: this.available_time,
    };

    if (this.availableForm.invalid) {
      this.availableForm.setErrors({
        invalidLogin: true,
      });
      this.acceptMessage = 'Please select a snooze time!';
      this.isAcceptLoading = false;
    } else {
      this.deliveryService
        .updateAutoAcceptingAndAccepting(
          this.acceptingOrderValue.id,
          this.acceptingOrderDetails
        )
        .subscribe({
          next: (res) => {
            this.getOrderActions();
            this.acceptSuccess = true;
            this.isAcceptLoading = false;
            this.onSnoozeCancel();
          },
          error: (error) => {
            console.log(error + 'Error acceptingOrder');
            this.acceptMessage = error;
            this.acceptSuccess = false;
            this.isAcceptLoading = false;
          }
        });
    }
  }
  onSnoozeCancel() {
    this.getOrderActions();
    $('#snoozeOrderModal').modal('hide');
  }

  onPrepTimeSelect({ time, platformData }) {
    this.prepTimeUpdateMsg = ''
    this.prepTimeUpdateSuccess = false
    let body = {
      prep_time: time,
    };
    this.deliveryService.updateOrderPrepTime(platformData.id, body)
      .subscribe({
        next: (res) => {
          console.log(res, "updateOrderPrepTime");
          this.prepTimeUpdateMsg = res.message
          this.prepTimeUpdateSuccess = true
        },
        error: (error) => {
          console.log(error, "error");
          this.prepTimeUpdateMsg = error
          this.prepTimeUpdateSuccess = false
        }
      })
  }
}
